import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { motion } from "framer-motion";
import "./RightChoice.css";

const RightChoice = () => {
  const data = [
    {
      head: "Super Fast Delivery",
      desc: "Deliver your music fast across 100+ platforms, including Spotify, Deezer and Pandora. Our music distribution service ensures your tracks reach a global audience quickly and efficiently.",
    },
    {
      head: "Lowest Release Plans",
      desc: "Choose our music distribution service for the quality and lowest release plans available. Enjoy affordable options while distributing your music widely, ensuring maximum reach without compromising on quality or features.",
    },
    {
      head: "Unlimited Releasing",
      desc: "Unlock unlimited releasing plans with our music distribution service. Distribute as many tracks as you want, ensuring your music reaches fans everywhere without restrictions. Elevate your music career effortlessly.",
    },
    {
      head: "Worldwide Delivery",
      desc: "Distribute your music worldwide with our top-tier music distribution service. Ensure your tracks reach audiences everywhere, expanding your global presence and connecting with fans across the globe seamlessly.",
    },
    {
      head: "CallerTune / CRBT",
      desc: "Enhance your reach with CallerTune and CRBT services through our music distribution platform. Make your music the sound people hear, boosting visibility and connecting with fans in a unique way.",
    },
    {
      head: "Free YouTube Content ID",
      desc: "Protect your music with Free YouTube Content ID through our music distribution service. Automatically track and monetize your content, ensuring you get paid whenever your music is used online.",
    },
    {
      head: "Instagram Profile Linking",
      desc: "Boost your music presence with Instagram Profile Linking. Seamlessly connect your tracks to your Instagram profile, enhancing visibility and engaging with your audience effectively.",
    },
    {
      head: "Spotify Profile Verification",
      desc: "Achieve Spotify Profile Verification with our music distribution service. Gain credibility and enhance your visibility on Spotify, ensuring fans recognize and trust your profile as an official artist account.",
    },
    {
      head: "WhatsApp/Email/Phone & Chat Support",
      desc: "Experience top-notch support with our music distribution service. Get assistance via WhatsApp, email, phone or chat, ensuring your inquiries are handled promptly and efficiently, so you can focus on your music.",
    },
    {
      head: "Monthly Revenue Reports",
      desc: "Stay informed with our monthly revenue reports. Track your earnings, analyze performance and optimize your strategy with detailed insights delivered regularly to maximize your music’s success.",
    },
  ];

  return (
    <section className="dashboard-benefits-section-premium">
      <Container>
        <div className="text-center mb-5">
          <motion.h6
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="text-uppercase text-purple mb-3 fw-bold tracking-widest"
          >
            <mark>SMART DASHBOARD</mark>
          </motion.h6>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="heading-premium-main text-white"
          >
            Smart <mark>Dashboard</mark> &
            Professional Benefits
          </motion.h2>
        </div>

        <Row className="align-items-center mt-5 gy-5">
          <Col lg={5}>
            <div className="benefits-scroll-wrapper-premium">
              <div className="benefits-scroll-content">
                {data.map((item, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ delay: index * 0.05 }}
                    viewport={{ once: true }}
                    className="benefit-card-premium-v2"
                  >
                    <div className="benefit-number-box">
                      {index + 1 < 10 ? `0${index + 1}` : index + 1}
                    </div>
                    <div className="benefit-text-box">
                      <h4 className="benefit-title-v2">{item.head}</h4>
                      <p className="benefit-desc-v2">{item.desc}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </Col>
          <Col lg={7}>
            <motion.div
              initial={{ opacity: 0, scale: 0.9, rotateY: 20 }}
              whileInView={{ opacity: 1, scale: 1, rotateY: 0 }}
              transition={{ duration: 1 }}
              className="dashboard-visual-container-premium"
            >
              <div className="dashboard-glass-base">
                <Image
                  src="Images/fttunes_smart_dashboard.jpeg"
                  alt="Dashboard Preview"
                  fluid
                  className="dashboard-main-img"
                />
              </div>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default RightChoice;
